import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './App.css';
import './Login.css';
import HomePage from './components/HomePage';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);

  const [shopName, setShopName] = useState('');
  const [shopImage, setShopImage] = useState(null);
  const [shopLogo, setShopLogo] = useState(null);

  // liveLocation ko ab shop address ke liye use kar rahe hain
  const [liveLocation, setLiveLocation] = useState('');
  const [shopLatitude, setShopLatitude] = useState('');
  const [shopLongitude, setShopLongitude] = useState('');
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationMessage, setLocationMessage] = useState('');

  const [vendorType, setVendorType] = useState('fastfood');
  const [groceryMode, setGroceryMode] = useState('retail');

  const navigate = useNavigate();

  const normalizeMobile = (value) =>
    String(value || '')
      .replace(/\D/g, '')
      .slice(0, 10);

  const isValidLatitude = (value) => {
    const num = Number(value);
    return Number.isFinite(num) && num >= -90 && num <= 90;
  };

  const isValidLongitude = (value) => {
    const num = Number(value);
    return Number.isFinite(num) && num >= -180 && num <= 180;
  };

  const buildFallbackAddress = (lat, lng) => {
    return `Shop Location: ${lat}, ${lng}`;
  };

  const reverseGeocodeAddress = async (lat, lng) => {
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${encodeURIComponent(
        lat
      )}&lon=${encodeURIComponent(lng)}`;

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        return '';
      }

      const data = await response.json();

      return data.display_name || '';
    } catch (error) {
      console.error('Reverse geocoding error:', error);
      return '';
    }
  };

  const handleUseCurrentLocation = () => {
    if (!navigator.geolocation) {
      setLocationMessage('Aapke browser/device me location support nahi hai.');
      return;
    }

    setLocationLoading(true);
    setLocationMessage('Shop location detect ho rahi hai...');

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = Number(position.coords.latitude).toFixed(8);
        const lng = Number(position.coords.longitude).toFixed(8);

        setShopLatitude(lat);
        setShopLongitude(lng);

        setLocationMessage('Location detect ho gayi. Address fetch ho raha hai...');

        const detectedAddress = await reverseGeocodeAddress(lat, lng);

        if (detectedAddress) {
          setLiveLocation(detectedAddress);
          setLocationMessage(
            'Shop location aur address auto fill ho gaya. Aap chahein to address edit kar sakte hain.'
          );
        } else {
          setLiveLocation((prev) => prev || buildFallbackAddress(lat, lng));
          setLocationMessage(
            'Location detect ho gayi. Address auto fill nahi hua, aap address manually edit kar sakte hain.'
          );
        }

        setLocationLoading(false);
      },
      (error) => {
        console.error('Location error:', error);

        let msg = 'Location allow nahi hua. Please browser permission allow karein.';

        if (error.code === 1) {
          msg = 'Location permission denied hai. Browser me location allow karein.';
        } else if (error.code === 2) {
          msg = 'Location available nahi hai. GPS/Internet check karein.';
        } else if (error.code === 3) {
          msg = 'Location detect karne me timeout ho gaya. Dobara try karein.';
        }

        setLocationMessage(msg);
        setLocationLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  };

  const validateForm = () => {
    if (!name.trim()) {
      alert('Name required hai.');
      return false;
    }

    if (!email.trim()) {
      alert('Email required hai.');
      return false;
    }

    const mobile = normalizeMobile(number);

    if (mobile.length !== 10) {
      alert('Valid 10 digit mobile number enter karein.');
      return false;
    }

    if (!password) {
      alert('Password required hai.');
      return false;
    }

    if (password !== confirmPassword) {
      setPasswordError(true);
      return false;
    }

    if (!shopName.trim()) {
      alert('Shop name required hai.');
      return false;
    }

    if (!vendorType) {
      alert('Business type select karein.');
      return false;
    }

    if (vendorType === 'grocery' && !['retail', 'wholesale'].includes(groceryMode)) {
      alert('Grocery mode retail ya wholesale select karein.');
      return false;
    }

    if (!liveLocation.trim()) {
      alert('Shop address required hai.');
      return false;
    }

    if (!isValidLatitude(shopLatitude) || !isValidLongitude(shopLongitude)) {
      alert('Please "Use My Shop Location" button se shop location detect karein.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const apiUrl = process.env.REACT_APP_API_URL || 'https://vakra.co.in/api';

    const formData = new FormData();

    formData.append('name', name.trim());
    formData.append('email', email.trim());
    formData.append('number', normalizeMobile(number));
    formData.append('password', password);
    formData.append('shopName', shopName.trim());

    if (shopImage) formData.append('shopImage', shopImage);
    if (shopLogo) formData.append('shopLogo', shopLogo);

    // liveLocation me ab readable shop address jayega
    formData.append('liveLocation', liveLocation.trim());

    // exact distance calculation ke liye ye alag jayega
    formData.append('shopLatitude', shopLatitude);
    formData.append('shopLongitude', shopLongitude);

    formData.append('vendorType', vendorType);

    if (vendorType === 'grocery') {
      formData.append('groceryMode', groceryMode);
    }

    try {
      const response = await fetch(`${apiUrl}/auth/signup`, {
        method: 'POST',
        body: formData,
      });

      const text = await response.text();

      let data;

      try {
        data = JSON.parse(text);
      } catch (jsonErr) {
        console.error('Response is not JSON:', text);
        alert('Server ne galat response bheja. Console check karo.');
        return;
      }

      console.log('Signup API Response:', data);

      if (response.ok) {
        alert(data.message || 'Signup successful!');
        navigate('/login');
      } else {
        alert(data.error || data.message || `Error ${response.status}: Signup failed!`);
      }
    } catch (error) {
      console.error('Signup fetch error:', error);

      alert(
        'Network ya server error!\n\nPossible reasons:\n' +
          '1. Server chal nahi raha ya galat URL hai\n' +
          '2. Internet check karo\n' +
          '3. Backend CORS issue\n' +
          '4. Domain/IP galat\n\n' +
          'Console me details dekho.'
      );
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) setShopImage(file);
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) setShopLogo(file);
  };

  return (
    <div className="login-wrapper">
      <HomePage />

      <div className="auth-container">
        <h2>Signup</h2>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile Number:</label>
            <input
              type="tel"
              value={number}
              onChange={(e) => setNumber(normalizeMobile(e.target.value))}
              placeholder="Enter 10 digit mobile number"
              maxLength={10}
              required
            />
          </div>

          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <div className="form-group">
            <label>Confirm Password:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                setPasswordError(false);
              }}
              placeholder="Confirm password"
              style={{ border: passwordError ? '2px solid red' : '1px solid black' }}
              required
            />

            {passwordError && (
              <p style={{ color: 'red', marginTop: '6px' }}>
                Passwords do not match!
              </p>
            )}
          </div>

          <div className="form-group">
            <label>Select Business Type:</label>
            <select
              value={vendorType}
              onChange={(e) => setVendorType(e.target.value)}
              required
            >
              <option value="fastfood">Fast Food</option>
              <option value="cosmetic">Cosmetic</option>
              <option value="garments">Garments</option>
              <option value="grocery">Grocery</option>
            </select>
          </div>

          {vendorType === 'grocery' && (
            <div className="form-group">
              <label>Select Grocery Mode:</label>
              <select
                value={groceryMode}
                onChange={(e) => setGroceryMode(e.target.value)}
                required
              >
                <option value="retail">Retail</option>
                <option value="wholesale">Wholesale</option>
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Shop Name:</label>
            <input
              type="text"
              value={shopName}
              onChange={(e) => setShopName(e.target.value)}
              placeholder="Enter shop name"
              required
            />
          </div>

          <div className="form-group">
            <label>Shop Image (optional):</label>
            <input type="file" accept="image/*" onChange={handleImageUpload} />
          </div>

          <div className="form-group">
            <label>Shop Logo (optional):</label>
            <input type="file" accept="image/*" onChange={handleLogoUpload} />
          </div>

          <div className="form-group">
            <label>Shop Address:</label>

            <button
              type="button"
              onClick={handleUseCurrentLocation}
              disabled={locationLoading}
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '8px',
                cursor: locationLoading ? 'not-allowed' : 'pointer',
              }}
            >
              {locationLoading ? 'Detecting Shop Location...' : '📍 Use My Shop Location'}
            </button>

            <textarea
              value={liveLocation}
              onChange={(e) => setLiveLocation(e.target.value)}
              placeholder="Enter shop full address"
              rows={3}
              required
              style={{
                width: '100%',
                resize: 'vertical',
                padding: '10px',
                boxSizing: 'border-box',
              }}
            />

            {locationMessage && (
              <p
                style={{
                  marginTop: '6px',
                  fontSize: '13px',
                  color:
                    shopLatitude && shopLongitude && !locationLoading
                      ? 'green'
                      : '#b45309',
                }}
              >
                {locationMessage}
              </p>
            )}

            {shopLatitude && shopLongitude && (
              <p style={{ marginTop: '6px', fontSize: '13px', color: '#374151' }}>
                Location detected: Lat {shopLatitude}, Lng {shopLongitude}
              </p>
            )}
          </div>

          <button type="submit">Signup</button>
        </form>

        <p>
          Already have an account? <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
